import { combineReducers } from 'redux';
import { setSnackbar } from './snackbar.reducers';
import { employeeList, empDetails, managerUpdate_Reducer, changeManager_Reducer, changeTeam_Reducer } from './user.reducer';
import { add_okrReducer } from './okrs.reducers';
import { fetchChartData_Reducer, orgStructure_Reducer } from './structure.reducer';
import {
    loadReportingManagers_Reducer,
    loadStatus_Reducer,
    loadUsers_Reducer,
    loadCommentsTypes_Reducer,
    loadDepartment_Reducer,
    loadTeam_Reducer,
    loadLocation_Reducer,
    loadJobTitle_Reducer,
    loadEmpType_Reducer,
    loadTrainingLevel_Reducer,
    loadTrainingType_Reducer,
    loadTrainingStatus_Reducer,
    loadEmpTrainingStatus_Reducer,
    loadEmployeeLevel_Reducer,
    loadYesNo_Reducer,
    loadReportingUsers_Reducer

} from './lookups.reducer';
import {fetchNotificationList_Reducer} from './notification.reducer';

import { addComments_Reducer } from './addComments.reducer';
import { fetchTrainingList_Reducer, fetchMyTraining_Reducer, fetchTeamTraining_Reducer, 
    fetchTrainingDetails_Reducer, fetchOngoingTraining_Reducer, fetchExternalTrainingList_Reducer, fetchAllExternalTraining_Reducer } from './training.reducer';


export default combineReducers({
    setSnackbar,
    employeeList,
    empDetails,
    add_okrReducer,
    fetchChartData_Reducer,
    loadReportingManagers_Reducer,
    loadStatus_Reducer,
    loadUsers_Reducer,
    loadCommentsTypes_Reducer,
    addComments_Reducer,
    loadDepartment_Reducer,
    loadTeam_Reducer,
    loadLocation_Reducer,
    loadJobTitle_Reducer,
    managerUpdate_Reducer,
    changeManager_Reducer,
    changeTeam_Reducer,
    fetchTrainingList_Reducer,
    loadEmpType_Reducer,
    orgStructure_Reducer,
    loadTrainingLevel_Reducer,
    loadTrainingType_Reducer,
    fetchMyTraining_Reducer,
    fetchTeamTraining_Reducer,
    loadTrainingStatus_Reducer,
    fetchTrainingDetails_Reducer,
    fetchOngoingTraining_Reducer,
    loadEmpTrainingStatus_Reducer,
    fetchNotificationList_Reducer,
    loadEmployeeLevel_Reducer,
    loadYesNo_Reducer,
    fetchExternalTrainingList_Reducer,
    loadReportingUsers_Reducer,
    fetchAllExternalTraining_Reducer

});